"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const profileSlice_1 = require("../../../../redux/slices/profileSlice");
const userSlice_1 = require("../../../../redux/slices/userSlice");
const common_1 = require("../../../../utils/common");
require("./work-samples.scss");
const core_1 = require("@material-ui/core");
const noSamples = `Please add a work sample to complete your profile.`;
const noSamplesGuest = `Information is not provided.`;
let fileInput = null;
class WorkSamples extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            filesLocalError: false
        };
        this.handleChange = async (e) => {
            const { profile: { userDocs: { data, newData } } } = this.props;
            const files = e.target.files;
            const totalFilesLength = data.length + files.length;
            if (totalFilesLength > 5) {
                return this.setState({ filesLocalError: 'You may attach no more than 5 files.' });
            }
            const newFiles = [];
            const uploads = [];
            let fileError = '';
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain'];
            for (const f of files) {
                const id = `${new Date().getUTCMilliseconds()}_file`;
                const obj = {
                    id,
                    name: f.name,
                    type: f.type,
                    size: f.size,
                    temp: true
                };
                if (validTypes.includes(f.type)) {
                    newFiles.push(obj);
                    f.id = id;
                    uploads.push(f);
                }
                else {
                    fileError = 'You may attach only pdf, jpg, jpeg, png, doc, docx or text.';
                }
            }
            this.props.updateUserDocs([...data, ...newFiles]);
            this.props.setNewDocs([...newData, ...newFiles]);
            this.props.onFileChange(uploads);
            this.setState({ filesLocalError: false });
            if (fileInput) {
                fileInput.value = "";
            }
            if (fileError) {
                return this.props.setFileError(fileError);
            }
        };
        this.handleUpload = (e) => {
            const { profile: { userDocs: { data } } } = this.props;
            const totalFilesLength = data.length + e.target.files.length;
            if (totalFilesLength > 5) {
                return this.setState({ filesLocalError: 'You may attach no more than 5 files.' });
            }
            const formData = new FormData();
            for (const f of e.target.files) {
                formData.append("file", f);
            }
            formData["id"] = this.props.user.id;
            this.props.uploadFile(formData);
            this.setState({ filesLocalError: false });
            if (fileInput) {
                fileInput.value = "";
            }
        };
        this.downloadFile = async (e, data) => {
            e.preventDefault();
            e.stopPropagation();
            const baseUrl = window.AppearMe.appConfigs.url;
            const url = `${baseUrl}/downloadFile?fileName=${data.name}&fileUrl=${data.url}`;
            common_1.goExternalUrl(url);
        };
        this.deleteFile = (id) => {
            const { profile: { userDocs: { data, newData } } } = this.props;
            let old = [...data];
            let unsaved = [...newData];
            let setNew = [];
            let updatedOld = old.filter(i => i.id !== id);
            const doc = old.find(i => i.id === id);
            if (doc.temp) {
                unsaved = unsaved.filter(i => i.id !== id);
                setNew = [...unsaved, ...updatedOld];
            }
            else {
                setNew = [...newData, Object.assign(Object.assign({}, doc), { deleted: true })];
            }
            this.props.updateUserDocs(updatedOld);
            this.props.setNewDocs(setNew);
            this.props.onFileChange([], id, true);
            this.setState({ filesLocalError: false });
        };
    }
    render() {
        var _a;
        const { edit = false, guest = false, profile: { userDocs: { data, fileError, fileLoading } } } = this.props;
        const { filesLocalError } = this.state;
        const files = (_a = data.filter(i => !i.deleted)) === null || _a === void 0 ? void 0 : _a.map(file => react_1.default.createElement("div", { className: "work-sample-row", key: file.id },
            react_1.default.createElement("span", { className: `attach ${file.temp ? "attach-black" : ""}` }),
            react_1.default.createElement("div", { className: "block" },
                !file.temp && react_1.default.createElement("a", { onClick: (e) => this.downloadFile(e, file), href: file.url }, file.name),
                file.temp && file.name,
                !guest && edit && react_1.default.createElement("span", { className: "delete", onClick: () => this.deleteFile(file.id) }))));
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: `section-info-head ${(files === null || files === void 0 ? void 0 : files.length) ? 'mb-5' : ''}` },
                react_1.default.createElement("div", { className: "section-info-title" }, "Work Samples"),
                !guest && react_1.default.createElement("label", { "data-qa": 'add-work-sample', className: "add-practice add-work", htmlFor: "attach-file" },
                    react_1.default.createElement("input", { onChange: (e) => edit ? this.handleChange(e) : this.handleUpload(e), accept: "image/jpeg, image/jpg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain", style: { display: 'none' }, id: "attach-file", multiple: true, name: "file", type: "file", ref: ref => fileInput = ref }),
                    react_1.default.createElement("span", { className: "attach-file" }, " Add "))),
            react_1.default.createElement("div", null,
                (files === null || files === void 0 ? void 0 : files.length) ? react_1.default.createElement("div", null, files) : '',
                !(files === null || files === void 0 ? void 0 : files.length) && react_1.default.createElement("div", { className: "common-text" }, !guest ? noSamples : noSamplesGuest),
                (filesLocalError || fileError) &&
                    react_1.default.createElement(core_1.FormHelperText, { error: true, className: "helper-text-error work-sample-error" }, filesLocalError || fileError),
                fileLoading && react_1.default.createElement("div", { className: 'm-auto file-loader' }))));
    }
}
const mapStateToProps = (state) => {
    const { user, profile } = state;
    return {
        user,
        profile
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateUserDocs: (data) => dispatch(profileSlice_1.updateUserDocs(data)),
        uploadFile: (data) => dispatch(userSlice_1.uploadFile(data)),
        deleteFile: (data) => dispatch(userSlice_1.deleteFile(data)),
        setNewDocs: (data) => dispatch(profileSlice_1.setNewDocs(data)),
        setFileError: (data) => dispatch(profileSlice_1.setFileError(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WorkSamples);
